import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, withKeys as _withKeys, Teleport as _Teleport, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "row justify-left q-py-sm no-wrap global_container",
  style: 'width: 100%; min-width: 880px;'
}
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = ["aria-label", "disabled"]
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["disabled", "aria-label"]
const _hoisted_7 = ["disabled", "aria-label"]
const _hoisted_8 = {
  key: 5,
  class: "ble-lite-menu__sep"
}
const _hoisted_9 = {
  key: 9,
  class: "ble-lite-menu__sep"
}
const _hoisted_10 = {
  key: 12,
  class: "ble-lite-menu__sep"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MostaSelect = _resolveComponent("MostaSelect")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_QueryTableLite = _resolveComponent("QueryTableLite")!
  const _component_mosta_context_menu = _resolveComponent("mosta-context-menu")!
  const _component_multi_edit_dialog = _resolveComponent("multi-edit-dialog")!
  const _component_person_edit_dialog = _resolveComponent("person-edit-dialog")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_analytic_permition_modal = _resolveComponent("analytic-permition-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      ref: "personTargetRef",
      style: _normalizeStyle(_ctx.wrapperStyle)
    }, [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        (!_ctx.isSector && !_ctx.isInDialog)
          ? (_openBlock(), _createBlock(_component_MostaSelect, {
              key: 0,
              modelValue: _ctx.widthModel,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.widthModel) = $event)),
              options: _ctx.widthOptions,
              class: "q-mr-xs",
              style: {"min-width":"180px","margin-top":"6px"}
            }, null, 8, ["modelValue", "options"]))
          : _createCommentVNode("", true),
        (_ctx.genstore.selectedItem && _ctx.genstore.selectedItem.Id)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: _normalizeClass(['qt-panel-icon-btn', { 'qt-panel-icon-btn--flat': _ctx.isSector }]),
              style: _normalizeStyle(
          !_ctx.isSector && !_ctx.isInDialog
            ? 'margin-top: 3px;'
            : 'margin-top: -3px;'
        ),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onRefreshTable(_ctx.pagination))),
              "aria-label": _ctx.$t('refresh_label')
            }, [
              _cache[32] || (_cache[32] = _createElementVNode("svg", {
                width: "20",
                height: "20",
                viewBox: "0 0 20 20",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  d: "M17.5 10C17.5 11.4834 17.0601 12.9334 16.236 14.1668C15.4119 15.4001 14.2406 16.3614 12.8701 16.9291C11.4997 17.4968 9.99168 17.6453 8.53683 17.3559C7.08197 17.0665 5.7456 16.3522 4.6967 15.3033C3.64781 14.2544 2.9335 12.918 2.64411 11.4632C2.35472 10.0083 2.50325 8.50032 3.07091 7.12987C3.63856 5.75943 4.59986 4.58809 5.83323 3.76398C7.0666 2.93987 8.51664 2.5 10 2.5C12.1 2.5 14.1083 3.33333 15.6167 4.78333L17.5 6.66667",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }),
                _createElementVNode("path", {
                  d: "M17.5 2.5V6.66667H13.3333",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                })
              ], -1)),
              _createVNode(_component_q_tooltip, {
                delay: 300,
                anchor: "top middle",
                self: "center middle"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('refresh_label')), 1)
                ]),
                _: 1
              })
            ], 14, _hoisted_2))
          : _createCommentVNode("", true),
        (
          (_ctx.genstore.selectedItem &&
            _ctx.genstore.selectedItem.DestType !== 6 &&
            [0, 1].includes(_ctx.genstore.selectedItem.elType) &&
            _ctx.querystore.getCurrentTable &&
            _ctx.querystore.getCurrentTable.HeaderRow &&
            _ctx.querystore.getCurrentTable.HeaderRow.length) ||
          _ctx.isSector
        )
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              type: "button",
              class: _normalizeClass(['qt-panel-icon-btn', { 'qt-panel-icon-btn--flat': _ctx.isSector }]),
              style: _normalizeStyle(
          !_ctx.isSector && !_ctx.isInDialog
            ? 'margin-top: 3px;'
            : 'margin-top: -3px;'
        ),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (
          _ctx.saveTableToFile(
            _ctx.genstore.selectedItem,
            _ctx.genstore.selectedItem ? _ctx.genstore.selectedItem.Name : ''
          )
        )),
              "aria-label": _ctx.$t('load'),
              disabled: _ctx.querystore.isLoading || _ctx.auxstore.isTableLoading
            }, [
              _cache[33] || (_cache[33] = _createElementVNode("svg", {
                width: "20",
                height: "20",
                viewBox: "0 0 20 20",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  d: "M10 12.5V2.5",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }),
                _createElementVNode("path", {
                  d: "M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }),
                _createElementVNode("path", {
                  d: "M5.83331 8.33337L9.99998 12.5L14.1666 8.33337",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                })
              ], -1)),
              _createVNode(_component_q_tooltip, {
                delay: 300,
                anchor: "top middle",
                self: "center middle"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('load')), 1)
                ]),
                _: 1
              })
            ], 14, _hoisted_3))
          : _createCommentVNode("", true),
        (_ctx.genstore.selectedItem)
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              type: "button",
              class: _normalizeClass(['qt-panel-icon-btn', { 'qt-panel-icon-btn--flat': _ctx.isSector }]),
              style: _normalizeStyle(
          !_ctx.isSector && !_ctx.isInDialog
            ? 'margin-top: 3px;'
            : 'margin-top: -3px;'
        ),
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.copyLinkToItem && _ctx.copyLinkToItem(...args))),
              "aria-label": _ctx.$t('copy_link')
            }, [
              _cache[34] || (_cache[34] = _createStaticVNode("<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14.5 6C15.3284 6 16 5.32843 16 4.5C16 3.67157 15.3284 3 14.5 3C13.6716 3 13 3.67157 13 4.5C13 5.32843 13.6716 6 14.5 6Z\" fill=\"currentColor\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M5.5 11C6.32843 11 7 10.3284 7 9.5C7 8.67157 6.32843 8 5.5 8C4.67157 8 4 8.67157 4 9.5C4 10.3284 4.67157 11 5.5 11Z\" fill=\"currentColor\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M14.5 16C15.3284 16 16 15.3284 16 14.5C16 13.6716 15.3284 13 14.5 13C13.6716 13 13 13.6716 13 14.5C13 15.3284 13.6716 16 14.5 16Z\" fill=\"currentColor\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M7.15833 11.2583L12.85 14.575\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M12.8417 5.42505L7.15833 8.74172\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg>", 1)),
              _createVNode(_component_q_tooltip, {
                delay: 300,
                anchor: "top middle",
                self: "center middle"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('copy_link')), 1)
                ]),
                _: 1
              })
            ], 14, _hoisted_4))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "q-mx-xs text-h8",
          style: _normalizeStyle(
          !_ctx.isSector && !_ctx.isInDialog
            ? 'margin-top: 14px; white-space: pre;'
            : 'margin-top: 8px; white-space: pre;'
        )
        }, _toDisplayString(_ctx.$t("table_rows_count")) + " " + _toDisplayString(_ctx.formattedTotalCount), 5),
        _withDirectives(_createElementVNode("div", {
          class: "q-mx-xs text-h8 q-ml-md",
          style: _normalizeStyle(
          !_ctx.isSector && !_ctx.isInDialog
            ? 'margin-top: 14px; white-space: pre;'
            : 'margin-top: 8px; white-space: pre;'
        )
        }, _toDisplayString(_ctx.$t("selected_label")) + " " + _toDisplayString(_ctx.headerCheckbox === "none"
            ? _ctx.selectedModel.length
            : Number(_ctx.pagination.total_count) - Number(_ctx.unselectedModel.length)), 5), [
          [_vShow, _ctx.multieditAllowed]
        ]),
        _createVNode(_component_q_space),
        _createElementVNode("div", {
          class: "text-h8",
          style: _normalizeStyle(
          (!_ctx.isSector && !_ctx.isInDialog ? 'margin-top: 14px;' : 'margin-top: 8px;') +
          ' white-space: nowrap;'
        )
        }, _toDisplayString(_ctx.$t("records_on_page")), 5),
        _createVNode(_component_q_input, {
          modelValue: _ctx.countOnPage,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.countOnPage) = $event)),
          modelModifiers: { number: true },
          type: "number",
          dense: "",
          class: "thin-input q-mx-sm",
          outlined: "",
          onBlur: _ctx.applyCountOnPage,
          onKeydown: _withKeys(_withModifiers(_ctx.applyCountOnPage, ["stop","prevent"]), ["enter"]),
          style: _normalizeStyle(`max-width: 70px; min-width: 70px; ${
          !_ctx.isSector && !_ctx.isInDialog ? 'margin-top: 10px;' : 'margin-top: 4px;'
        } font-size: 16px !important;`)
        }, null, 8, ["modelValue", "onBlur", "onKeydown", "style"]),
        _createElementVNode("div", {
          class: "text-h8 q-mx-sm",
          style: _normalizeStyle(
          !_ctx.isSector && !_ctx.isInDialog ? 'margin-top: 14px;' : 'margin-top: 8px;'
        )
        }, [
          (_ctx.modelValue && _ctx.modelValue.SavedStateCalculatedAt)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, " " + _toDisplayString(_ctx.$t("current_at")) + " " + _toDisplayString(_ctx.lastCalcDate), 1))
            : _createCommentVNode("", true)
        ], 4),
        _createElementVNode("button", {
          class: "mini-nav-btn",
          style: _normalizeStyle(
          !_ctx.isSector && !_ctx.isInDialog
            ? 'margin-top: 11px;'
            : 'margin-top: 5px;'
        ),
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args))),
          disabled: 
          _ctx.querystore.isLoading ||
          _ctx.auxstore.isTableLoading ||
          (!_ctx.isSector && !_ctx.theModel) ||
          _ctx.pagination.offset <= 0
        ,
          "aria-label": _ctx.$t('prev_page')
        }, _cache[35] || (_cache[35] = [
          _createElementVNode("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            _createElementVNode("path", {
              d: "M10 3L5 8L10 13",
              stroke: "currentColor",
              "stroke-width": "1.8",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            })
          ], -1)
        ]), 12, _hoisted_6),
        _createElementVNode("div", {
          class: "text-h8",
          style: _normalizeStyle(
          !_ctx.isSector && !_ctx.isInDialog
            ? 'margin-top: 14px; white-space: pre;'
            : 'margin-top: 8px; white-space: pre;'
        )
        }, _toDisplayString(_ctx.$t("page")), 5),
        _createVNode(_component_q_input, {
          modelValue: _ctx.pageNum,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.pageNum) = $event)),
          modelModifiers: { number: true },
          type: "number",
          dense: "",
          class: "thin-input q-mx-sm",
          outlined: "",
          onBlur: _ctx.applyPageNum,
          onKeydown: _withKeys(_withModifiers(_ctx.applyPageNum, ["stop","prevent"]), ["enter"]),
          style: _normalizeStyle(`max-width: 70px; min-width: 70px; ${
          !_ctx.isSector && !_ctx.isInDialog ? 'margin-top: 10px;' : 'margin-top: 4px;'
        } font-size: 16px !important;`)
        }, null, 8, ["modelValue", "onBlur", "onKeydown", "style"]),
        _createElementVNode("div", {
          class: "text-h8",
          style: _normalizeStyle(
          !_ctx.isSector && !_ctx.isInDialog
            ? 'margin-top: 14px; white-space: pre;'
            : 'margin-top: 8px; white-space: pre;'
        )
        }, " /" + _toDisplayString(_ctx.pagesCount), 5),
        _createElementVNode("button", {
          class: "mini-nav-btn",
          style: _normalizeStyle(
          !_ctx.isSector && !_ctx.isInDialog
            ? 'margin-top: 11px;'
            : 'margin-top: 5px;'
        ),
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
          disabled: 
          _ctx.querystore.isLoading ||
          _ctx.auxstore.isTableLoading ||
          (!_ctx.isSector && !_ctx.theModel) ||
          _ctx.currentPage >= _ctx.pagesCount
        ,
          "aria-label": _ctx.$t('next_page')
        }, _cache[36] || (_cache[36] = [
          _createElementVNode("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            _createElementVNode("path", {
              d: "M6 3L11 8L6 13",
              stroke: "currentColor",
              "stroke-width": "1.8",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            })
          ], -1)
        ]), 12, _hoisted_7)
      ], 512), [
        [_vShow, !_ctx.hidePanel]
      ]),
      _createElementVNode("div", {
        style: _normalizeStyle(`${
        !_ctx.isSector && !_ctx.isInDialog
          ? 'flex: 1 1 0; min-height: 0; display: flex; flex-direction: column; overflow: hidden; background: transparent;'
          : ''
      } `),
        ref: "table_container",
        class: "table_container"
      }, [
        _createVNode(_component_QueryTableLite, {
          modelValue: _ctx.theModel,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.theModel) = $event)),
          "src-element": _ctx.srcElement,
          paginationModel: _ctx.pagination,
          selectedEverything: _ctx.selectedEverything,
          selectedEntities: _ctx.selectedEntities,
          unselectedEntities: _ctx.unselectedEntities,
          "hide-panel": _ctx.hidePanel,
          "is-sector": _ctx.isSector,
          "is-in-dialog": _ctx.isInDialog,
          "onUpdate:paginationModel": _cache[9] || (_cache[9] = (v) => _ctx.$emit('update:paginationModel', v)),
          "onUpdate:selectedEverything": _cache[10] || (_cache[10] = (v) => _ctx.emitSelectedAll(v)),
          "onUpdate:selectedEntities": _cache[11] || (_cache[11] = (v) => _ctx.emitSelected(v)),
          "onUpdate:unselectedEntities": _cache[12] || (_cache[12] = (v) => _ctx.emitUnselected(v)),
          onSelectionChangeManual: _cache[13] || (_cache[13] = ($event: any) => (_ctx.emitSelectionChangeManual())),
          onRefreshPage: _cache[14] || (_cache[14] = (v) => _ctx.emitRefreshPage(v)),
          onReloadTable: _cache[15] || (_cache[15] = ($event: any) => (_ctx.emitReloadTable(undefined))),
          onRefreshNeeded: _cache[16] || (_cache[16] = ($event: any) => (_ctx.onRefreshTable(_ctx.pagination, false))),
          onAddCommentColumn: _ctx.onAddCommentColumn,
          onMultieditClick: _ctx.onLiteMultieditClick,
          onTogglePinnedOrder: _ctx.globalPinnedOrder,
          onUpdatePerson: _cache[17] || (_cache[17] = ($event) => _ctx.updatePerson($event.ev, $event.entityId))
        }, null, 8, ["modelValue", "src-element", "paginationModel", "selectedEverything", "selectedEntities", "unselectedEntities", "hide-panel", "is-sector", "is-in-dialog", "onAddCommentColumn", "onMultieditClick", "onTogglePinnedOrder"]),
        _createVNode(_component_mosta_context_menu, {
          visible: _ctx.liteMultieditMenuVisible,
          position: _ctx.liteMultieditMenuPos,
          "min-width": 200,
          "menu-class": "ble-lite-menu ble-lite-menu--multiedit",
          onClose: _ctx.closeLiteMultieditMenu
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "ble-lite-menu__item",
              onClick: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (_ctx.onLiteMenuAction(5, 1, _ctx.liteMenuText.addToList, undefined, $event)), ["stop"]))
            }, _toDisplayString(_ctx.liteMenuText.addToList), 1),
            (_ctx.srcElement && [6].includes(_ctx.srcElement?.elType))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "ble-lite-menu__item",
                  onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (_ctx.onLiteMenuAction(5, 2, _ctx.liteMenuText.deleteFromList, undefined, $event)), ["stop"]))
                }, _toDisplayString(_ctx.liteMenuText.deleteFromList), 1))
              : _createCommentVNode("", true),
            _cache[37] || (_cache[37] = _createElementVNode("div", { class: "ble-lite-menu__sep" }, null, -1)),
            (_ctx.srcElement && ![7,8].includes(_ctx.srcElement?.DestType))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "ble-lite-menu__item",
                  onClick: _cache[20] || (_cache[20] = _withModifiers(($event: any) => (_ctx.onLiteMenuAction(4, 1, _ctx.liteMenuText.deleteElements, undefined, $event)), ["stop"]))
                }, _toDisplayString(_ctx.liteMenuText.deleteElements), 1))
              : _createCommentVNode("", true),
            _cache[38] || (_cache[38] = _createElementVNode("div", { class: "ble-lite-menu__sep" }, null, -1)),
            (_ctx.srcElement && ![5,7,8].includes(_ctx.srcElement?.DestType))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "ble-lite-menu__item",
                  onClick: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (_ctx.onLiteMenuAction(1, 1, _ctx.liteMenuText.addTags, undefined, $event)), ["stop"]))
                }, _toDisplayString(_ctx.liteMenuText.addTags), 1))
              : _createCommentVNode("", true),
            (_ctx.srcElement && [5].includes(_ctx.srcElement?.DestType))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 3,
                  class: "ble-lite-menu__item",
                  onClick: _cache[22] || (_cache[22] = _withModifiers(($event: any) => (_ctx.onLiteMenuAction(1, 3, _ctx.liteMenuText.changeTagsStatus, undefined, $event)), ["stop"]))
                }, _toDisplayString(_ctx.liteMenuText.changeTagsStatus), 1))
              : _createCommentVNode("", true),
            (_ctx.srcElement && ![5,7,8].includes(_ctx.srcElement?.DestType))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 4,
                  class: "ble-lite-menu__item",
                  onClick: _cache[23] || (_cache[23] = _withModifiers(($event: any) => (_ctx.onLiteMenuAction(1, 2, _ctx.liteMenuText.removeTags, undefined, $event)), ["stop"]))
                }, _toDisplayString(_ctx.liteMenuText.removeTags), 1))
              : _createCommentVNode("", true),
            (_ctx.srcElement && [0,1].includes(_ctx.srcElement?.DestType))
              ? (_openBlock(), _createElementBlock("div", _hoisted_8))
              : _createCommentVNode("", true),
            (_ctx.srcElement && [0,1].includes(_ctx.srcElement?.DestType))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 6,
                  class: "ble-lite-menu__item",
                  onClick: _cache[24] || (_cache[24] = _withModifiers(($event: any) => (_ctx.onLiteMenuAction(15, 1, _ctx.liteMenuText.addParameters, undefined, $event)), ["stop"]))
                }, _toDisplayString(_ctx.liteMenuText.addParameters), 1))
              : _createCommentVNode("", true),
            (_ctx.srcElement && [0,1,7].includes(_ctx.srcElement?.DestType))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 7,
                  class: "ble-lite-menu__item",
                  onClick: _cache[25] || (_cache[25] = _withModifiers(($event: any) => (_ctx.onLiteMenuAction(15, 2, _ctx.liteMenuText.editParameter, undefined, $event)), ["stop"]))
                }, _toDisplayString(_ctx.liteMenuText.editParameter), 1))
              : _createCommentVNode("", true),
            (_ctx.srcElement && [0,1].includes(_ctx.srcElement?.DestType))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 8,
                  class: "ble-lite-menu__item",
                  onClick: _cache[26] || (_cache[26] = _withModifiers(($event: any) => (_ctx.onLiteMenuAction(15, 3, _ctx.liteMenuText.deleteParameters, undefined, $event)), ["stop"]))
                }, _toDisplayString(_ctx.liteMenuText.deleteParameters), 1))
              : _createCommentVNode("", true),
            (_ctx.showDetailsEntry || _ctx.showCommentEntry)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9))
              : _createCommentVNode("", true),
            (_ctx.showDetailsEntry)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 10,
                  class: "ble-lite-menu__item",
                  onClick: _cache[27] || (_cache[27] = _withModifiers(($event: any) => (_ctx.onLiteMenuAction(6, 2, _ctx.liteMenuText.changeDetails, 1, $event)), ["stop"]))
                }, _toDisplayString(_ctx.liteMenuText.editParameter), 1))
              : _createCommentVNode("", true),
            (_ctx.showCommentEntry)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 11,
                  class: "ble-lite-menu__item",
                  onClick: _cache[28] || (_cache[28] = _withModifiers(($event: any) => (_ctx.onLiteMenuAction(6, 3, _ctx.liteMenuText.changeComment, 1, $event)), ["stop"]))
                }, _toDisplayString(_ctx.liteMenuText.editParameter), 1))
              : _createCommentVNode("", true),
            (_ctx.srcElement && [0,1].includes(_ctx.srcElement?.DestType))
              ? (_openBlock(), _createElementBlock("div", _hoisted_10))
              : _createCommentVNode("", true),
            (_ctx.srcElement && [0,1].includes(_ctx.srcElement?.DestType))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 13,
                  class: "ble-lite-menu__item",
                  onClick: _cache[29] || (_cache[29] = _withModifiers(($event: any) => (_ctx.openPermitionsModal()), ["stop"]))
                }, _toDisplayString(`Изменить права`)))
              : _createCommentVNode("", true)
          ]),
          _: 1,
          __: [37,38]
        }, 8, ["visible", "position", "onClose"]),
        (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
          (_ctx.tagMultieditDialog)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                ref: "multieditDialogWrap",
                class: "med-dialog-popup",
                style: _normalizeStyle(_ctx.multieditDialogPosStyle)
              }, [
                _createVNode(_component_multi_edit_dialog, {
                  entities: _ctx.entitiesForMultiedit,
                  totalElements: 
              _ctx.headerCheckbox === 'none'
                ? _ctx.selectedModel.length
                : Number(_ctx.pagination.total_count) - Number(_ctx.unselectedModel.length)
            ,
                  "all-checked": !_ctx.isSector ? _ctx.headerCheckbox !== 'none' : false,
                  "model-type": _ctx.multiEditType,
                  "parameter-mode": _ctx.multiEditMode,
                  "comment-action-type": _ctx.multiEditCommentAction,
                  "header-text": _ctx.multiEditHeader,
                  "has-comment-column": _ctx.hasTableCommentColumn,
                  "details-edit-allowed": _ctx.canEditDetails,
                  "src-element": _ctx.srcElement,
                  onRefreshNeeded: _ctx.onMultiEditRefreshNeeded,
                  onSelectorClosed: _ctx.closeMultieditDialog
                }, null, 8, ["entities", "totalElements", "all-checked", "model-type", "parameter-mode", "comment-action-type", "header-text", "has-comment-column", "details-edit-allowed", "src-element", "onRefreshNeeded", "onSelectorClosed"])
              ], 4))
            : _createCommentVNode("", true)
        ])),
        _createVNode(_component_q_dialog, {
          modelValue: _ctx.personEditDialog,
          "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.personEditDialog) = $event)),
          "no-backdrop-dismiss": "",
          class: "person-dialog"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_person_edit_dialog, {
              entityId: _ctx.personEditData,
              "src-element": _ctx.srcElement,
              marginx: _ctx.persMarginX,
              marginy: _ctx.persMarginY,
              onRefreshNeeded: _cache[30] || (_cache[30] = ($event: any) => (_ctx.onRefreshTable(_ctx.pagination, false)))
            }, null, 8, ["entityId", "src-element", "marginx", "marginy"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 4)
    ], 4),
    _createVNode(_component_analytic_permition_modal, {
      ref: "analyticPermitionModal",
      title: 'Изменение прав доступа',
      onSaved: _ctx.onPermitionsSaved
    }, null, 8, ["onSaved"])
  ], 64))
}